// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const mt: KnowledgePagesCopy = {
  knowledgePage: 'Paġna tal-għarfien',
  knowledgePages: 'Paġni tal-għarfien',
  featureOffTitle: 'Il-paġni tal-għarfien mhumiex attivati f’dan l-ispazju tax-xogħol.',
  featureOffBody: 'Il-kuntest u s-sorsi tal-kumpanija għadhom f’Għarfien.',
  loadingPage: 'Qed titgħabba l-paġna…',
  loadingSuggestion: 'Qed jitgħabba s-suġġeriment…',
  cancel: 'Ikkanċella',
  tryAgain: 'Erġa’ pprova',
  everyoneIn: 'Kulħadd ġewwa {company}',
  yourCompany: 'il-kumpanija tiegħek',
  revision: 'Verżjoni {n}',
  openRevision: 'Iftaħ il-verżjoni {n}',
  pageCount: 'one:paġna|two:paġni|few:paġni|many:paġna|other:paġna',
  topicCount: 'one:suġġett|two:suġġetti|few:suġġetti|many:suġġett|other:suġġett',
  sectionCount: 'one:taqsima|two:taqsimiet|few:taqsimiet|many:taqsima|other:taqsima',
  lineCount: 'one:linja|two:linji|few:linji|many:linja|other:linja',
  documentCount: 'one:dokument|two:dokumenti|few:dokumenti|many:dokument|other:dokument',
  changeCount: 'one:bidla|two:bidliet|few:bidliet|many:bidla|other:bidla',
  newPageCount:
    'one:paġna ġdida|two:paġni ġodda|few:paġni ġodda|many:paġna ġdida|other:paġna ġdida',
  changedPageCount:
    'one:paġna mibdula|two:paġni mibdula|few:paġni mibdula|many:paġna mibdula|other:paġna mibdula',
  otherSectionCount:
    'one:taqsima oħra|two:taqsimiet oħra|few:taqsimiet oħra|many:taqsima oħra|other:taqsima oħra',
  characterCount: 'one:karattru|two:karattri|few:karattri|many:karattru|other:karattru',
  diffStats: '{sections} mibdula · {added} miżjuda · {removed} imneħħija',
  diffMatchesBase: 'It-test propost jaqbel mal-verżjoni bażi.',
  diffIntroduction: 'Introduzzjoni',
  diffOtherUnchanged: '{sections} mhux mibdula.',
  timeJustNow: 'issa stess',
  originImportedFrom: 'Importat minn {path}',
  originImportedFromCommit: 'Importat minn {path} @ {commit}',
  authorityApprovedInPoneva: 'Approvat f’Poneva',
  authorityImported: 'Importat',
  authorityInRepository: '{canonicality} fir-repożitorju',
  authorityVerified: 'ivverifikat {date}',
  authorRepositoryImport: 'Importazzjoni mir-repożitorju',
  authorSuggestedInChat: 'Issuġġerit fiċ-chat',
  authorSuggestedInChatWith: 'Issuġġerit fiċ-chat ma’ {name}',
  authorSuggestedBy: 'Issuġġerit minn {name}',
  authorSuggestedByApp: 'Issuġġerit minn app konnessa',
  authorSuggestedByColleague: 'Issuġġerit minn kollega',
  authorSuggestedByYou: 'Issuġġerit minnek',
  authorSuggestedOnBehalf: 'Issuġġerit minn {app} f’isem {name}',
  authorSuggestedByAppOnBehalf: 'Issuġġerit minn app konnessa f’isem {name}',
  authorSuggestedAndApproved: 'Issuġġerit u approvat minn {name}',
  approverApprovedBy: 'approvat minn {name}',
  approverAppliedBy: 'applikat minn {name}',
  kindCreatePage: 'Paġna ġdida',
  kindUpdatePage: 'Aġġornament propost',
  kindArchivePage: 'Arkivjar',
  statusConflict: 'Kunflitt · il-paġna nbidlet',
  statusPending: 'Qed jistenna r-reviżjoni',
  statusApproved: 'Approvat',
  statusRejected: 'Imwarrab',
  statusWithdrawn: 'Irtirat',
  statusSuperseded: 'Sostitwit',
  errRevisionConflict: 'Din il-paġna nbidlet waqt li kont qed tirrevediha.',
  errProposalChanged:
    'Dan is-suġġeriment inbidel waqt li kont qed tirrevedih. Irrevedi l-aħħar verżjoni qabel ma tiddeċiedi.',
  errPublishRequired:
    'Il-pubblikaturi tal-kumpanija biss jistgħu japprovaw bidliet fl-għarfien jew jimportaw paġni.',
  errProposalLimit:
    'Il-kumpanija tiegħek diġà għandha 200 suġġeriment jistennew ir-reviżjoni. Irrevedi xi wħud qabel ma tissuġġerixxi aktar.',
  errAuthorLimit:
    'Diġà għandek 50 suġġeriment jistennew ir-reviżjoni. Stenna sakemm xi wħud jiġu deċiżi, jew irtira xi wħud, qabel ma tissuġġerixxi aktar.',
  errImportProposalLimit:
    'Din l-importazzjoni żżid aktar paġni mibdula għar-reviżjoni milli jesgħu fil-kju tar-reviżjoni tal-kumpanija tiegħek (200 l-aktar). Iddeċiedi dwar xi suġġerimenti f’Għar-reviżjoni, imbagħad erġa’ applika.',
  errImportChanged:
    'Din l-importazzjoni mhix dik li rrevedejt. Erġa’ iftaħha u rrevediha qabel ma tapplikaha.',
  errImportItemNotFound: 'Dan id-dokument m’għadux parti mill-importazzjoni.',
  errIdempotencyConflict:
    'Dan is-suġġeriment diġà ntbagħat b’kontenut differenti. Aġġorna l-paġna u erġa’ pprova.',
  errImportHashMismatch:
    'Fajl f’dan is-snapshot ma jaqbilx mal-checksum irreġistrat tiegħu. Oħloq is-snapshot mill-ġdid u erġa’ pprova.',
  errImportAlreadyApplied: 'Din l-importazzjoni diġà ġiet applikata.',
  errImportDiscarded: 'Din l-importazzjoni ġiet skartata. Erġa’ agħżel il-fajl tas-snapshot.',
  errImportDuplicateItem:
    'Dan is-snapshot jelenka l-istess dokument darbtejn. Oħloq is-snapshot mill-ġdid.',
  errInvalidImport:
    'Poneva ma setax jaċċetta dan is-snapshot. Oħolqu mill-ġdid bl-iskript tas-snapshot u erġa’ pprova.',
  errInvalidInput: 'Poneva ma setax jaċċetta dan l-input. Iċċekkja l-oqsma u erġa’ pprova.',
  errImportLimit:
    'Hemm wisq importazzjonijiet ippreparati iżda mhux applikati. Applika jew skarta xi wħud qabel ma tipprepara oħra.',
  errPageTooLarge: 'Paġna hija akbar minn 256 KB. Aqsamha f’paġni iżgħar.',
  errTooManySections: 'Paġna għandha aktar minn 2,000 intestatura. Aqsamha f’paġni iżgħar.',
  errPageLimit: 'Il-kumpanija tiegħek laħqet il-limitu ta’ 2,000 paġna tal-għarfien.',
  errCollectionLimit: 'Il-kumpanija tiegħek laħqet il-limitu ta’ 100 suġġett.',
  errProposalNotPending: 'Dan is-suġġeriment diġà ġie deċiż. L-istatus muri huwa dak attwali.',
  errRequesterRemoved:
    'Il-persuna li ssuġġeriet dan m’għadhiex f’din il-kumpanija, għalhekk ma jistax jiġi approvat.',
  errRevisionAlreadyCurrent: 'Dik il-verżjoni diġà hija l-verżjoni attwali.',
  errPageArchived:
    'Din il-paġna ġiet arkivjata waqt li kont qed tirrevediha. Erġa’ rrevedi s-suġġeriment qabel ma tiddeċiedi.',
  errAlreadyArchived: 'Din il-paġna diġà hija arkivjata.',
  errProposalForbidden: 'Il-persuna li ssuġġeriet dan biss tista’ tirtirah.',
  errUnavailable: 'Il-paġni tal-għarfien mhumiex disponibbli bħalissa.',
  errTimeout: 'Poneva dam wisq biex iwieġeb.',
  errItemTooLarge: '{path} huwa akbar minn 256 KB. Aqsmu f’paġni iżgħar.',
  errItemTooManySections: '{path} għandu aktar minn 2,000 intestatura. Aqsmu f’paġni iżgħar.',
  errItemHashMismatch:
    '{path} ma jaqbilx mal-checksum irreġistrat tiegħu. Oħloq is-snapshot mill-ġdid u erġa’ pprova.',
  errNoLongerAvailable: 'Dan l-element m’għadux disponibbli għalik.',
  errTooLargeToSend: 'Dan il-fajl huwa kbir wisq biex jintbagħat.',
  cardChecking: 'Qed jiċċekkja l-istatus…',
  cardNotAvailable: 'Mhux disponibbli',
  cardStatusUnavailable: 'L-istatus mhux disponibbli',
  cardUnshowable: 'Dan l-aġġornament issuġġerit tal-għarfien ma setax jintwera.',
  cardEyebrow: 'Aġġornament issuġġerit tal-għarfien',
  cardLabel: 'Aġġornament issuġġerit tal-għarfien · {title}',
  cardMissing: 'Dan is-suġġeriment m’għadux disponibbli għalik.',
  cardUnknown:
    'Ma stajniex niċċekkjaw fejn wasal dan is-suġġeriment. Iftaħ ir-reviżjoni biex tara l-istatus tiegħu.',
  cardCheckAgain: 'Iċċekkja mill-ġdid',
  cardReview: 'Irrevedi l-aġġornament',
  statusLineApproved: 'Fehim approvat',
  readyCount:
    'one:lest għat-tfittxija|two:lesti għat-tfittxija|few:lesti għat-tfittxija|many:lesti għat-tfittxija|other:lesti għat-tfittxija',
  preparingCount:
    'one:qed jitħejja|two:qed jitħejjew|few:qed jitħejjew|many:qed jitħejjew|other:qed jitħejjew',
  attentionCount:
    'one:jeħtieġ attenzjoni|two:jeħtieġu attenzjoni|few:jeħtieġu attenzjoni|many:jeħtieġu attenzjoni|other:jeħtieġu attenzjoni',
  topicsExplore: 'Esplora suġġett',
  topicsAllPages: 'Il-paġni kollha',
  topicsOpenPages: 'Iftaħ Paġni',
  topicsEmpty:
    'Għad m’hemm l-ebda paġna approvata. Il-paġni jżommu fehim dettaljat tal-kumpanija bl-istorja sħiħa tal-verżjonijiet tiegħu.',
  reviewsTitle: 'Aġġornamenti ssuġġeriti tal-paġni',
  reviewsTitleMine: 'L-aġġornamenti tal-paġni li ssuġġerejt',
  reviewsIntro:
    'Kull suġġeriment huwa verżjoni kandidata sħiħa bir-raġuni u l-evidenza tagħha. Xejn ma jinbidel sakemm ma tapprovax eżattament dik il-verżjoni.',
  reviewsIntroMine:
    'Is-suġġerimenti tiegħek jistennew hawn sakemm pubblikatur tal-kumpanija jirrevedihom. Sa dakinhar il-paġni jibqgħu kif inhuma.',
  loadPagesFailed: 'Ma stajniex intellgħu l-paġni tal-għarfien.',
  loadProposalsFailed: 'Ma stajniex intellgħu l-aġġornamenti ssuġġeriti tal-paġni.',
  loadMoreFailed: 'Ma stajniex intellgħu aktar paġni.',
  otherPages: 'Paġni oħra',
  loadTopicFailed: 'Ma stajniex intellgħu dan is-suġġett.',
  revisionShort: 'v{n}',
  updatedOn: 'Aġġornat {date}',
  emptyTitle: 'Għad m’hemm l-ebda paġna tal-għarfien.',
  emptyBody:
    'Il-paġni jżommu l-fehim approvat u dettaljat tal-kumpanija tiegħek — direzzjoni, deċiżjonijiet u modi ta’ kif taħdmu — b’kull verżjoni miżmuma. Importa minn snapshot ta’ repożitorju jew ibda paġna fiċ-chat; pubblikatur japprova kull paġna qabel ma titqies bħala għarfien tal-kumpanija.',
  importFromSnapshot: 'Importa minn snapshot ta’ repożitorju',
  startInChat: 'Ibda paġna fiċ-chat',
  startInChatPrompt:
    'Għinni nibda paġna tal-għarfien għall-kumpanija tagħna. Staqsini x’għandha tkopri u tivvintax kontenut. Tibqa’ suġġeriment sakemm pubblikatur tal-kumpanija japprovaha.',
  loadingPages: 'Qed jitgħabbew il-paġni tal-għarfien…',
  filterLabel: 'Iffiltra l-paġni skont it-titlu',
  filterPlaceholder: 'Iffiltra l-paġni',
  importButton: 'Importa',
  showingTopic: 'Qed jintwera {topic}',
  showAllTopics: 'Uri s-suġġetti kollha',
  loadingTopic: 'Qed jitgħabba dan is-suġġett…',
  noMatch: 'L-ebda paġna ma taqbel ma’ “{filter}”.',
  topicNoPages: 'Għad m’hemm l-ebda paġna approvata f’dan is-suġġett.',
  loading: 'Qed jitgħabba…',
  loadMore: 'Għabbi aktar paġni',
  metaApproved: 'approvat {date}',
  metaRepositoryAuthoritative: 'ir-repożitorju jibqa’ s-sors awtorevoli',
  loadPageFailed: 'Ma stajniex intellgħu din il-paġna.',
  loadHistoryFailed: 'Ma stajniex intellgħu l-istorja tal-verżjonijiet.',
  outlineLabel: 'Taqsimiet tal-paġna',
  outlineToggle: 'F’din il-paġna',
  loadingHistory: 'Qed titgħabba l-istorja tal-verżjonijiet…',
  historyLabel: 'Storja tal-verżjonijiet',
  historyIntro:
    'Kull verżjoni approvata tinżamm. Jekk tirrestawra verżjoni preċedenti, jinħoloq suġġeriment għar-reviżjoni; qatt ma jitħassru verżjonijiet aktar tard.',
  historyCurrent: 'Attwali',
  historyViewing: 'Qed tara',
  historyView: 'Ara',
  historyViewAria: 'Ara l-verżjoni {n}',
  restoreAria: 'Irrestawra bħala suġġeriment: verżjoni {n}',
  restoreCreating: 'Qed jinħoloq is-suġġeriment…',
  restore: 'Irrestawra bħala suġġeriment',
  restoreUnconfirmed:
    'Ma stajniex nikkonfermaw li s-suġġeriment inħoloq. Iċċekkja Għar-reviżjoni qabel ma terġa’ tipprova.',
  editTooLarge:
    'Din il-paġna hija akbar minn 256 KB. Aqsamha f’paġni iżgħar qabel ma tissuġġeriha.',
  editConflict:
    'Din il-paġna nbidlet waqt li kont qed teditjaha. Ikkopja t-test tiegħek, iftaħ l-aħħar verżjoni u erġa’ ssuġġerixxi l-bidla.',
  editUnconfirmed:
    'Ma stajniex nikkonfermaw li s-suġġeriment tiegħek intbagħat. Iċċekkja Għar-reviżjoni qabel ma terġa’ tibagħtu.',
  editHeading: 'Issuġġerixxi bidla',
  editIntro:
    'Qed teditja l-verżjoni {n}. Pubblikatur tal-kumpanija jirrevedi l-bidla eżatta qabel ma ssir il-verżjoni {next}; sa dakinhar il-paġna tibqa’ kif inhi.',
  editOutdated:
    'Verżjoni aktar ġdida ġiet approvata waqt li kont qed teditja. Ikkopja t-test tiegħek, imbagħad erġa’ ibda mill-aħħar verżjoni biex ma jintilef xejn minn dak li biddlet.',
  editContentLabel: 'Kontenut tal-paġna (Markdown)',
  editReasonLabel: 'Għaliex din il-bidla?',
  editReasonPlaceholder: 'X’inbidel, u minn fejn ġej.',
  editSending: 'Qed jintbagħat…',
  editSend: 'Ibgħat għar-reviżjoni',
  editDiscardConfirm: 'Twarrab din il-bidla? Xejn minn dak li biddilt ma ntbagħat.',
  editNoChanges: 'Għad m’hemm l-ebda bidla.',
  editNeedsContent: 'Paġna teħtieġ xi kontenut.',
  exportFailed: 'Ma stajniex nesportaw din il-paġna. Erġa’ pprova.',
  askPagePrompt: 'Mistoqsija dwar il-paġna tal-għarfien “{title}” (verżjoni {n}, {link}):',
  askPageSectionPrompt:
    'Mistoqsija dwar il-paġna tal-għarfien “{title}” § {section} (verżjoni {n}, {link}):',
  pageMissingTitle: 'Din il-paġna mhix disponibbli.',
  pageMissingBody:
    'Forsi ġiet arkivjata, jew forsi m’għadx għandek aċċess għall-għarfien ta’ din il-kumpanija.',
  pageArchived: 'Arkivjata',
  viewingRevisionCurrent: 'Qed tara l-verżjoni {n}; il-verżjoni attwali hija {current}.',
  viewingRevisionOld: 'Qed tara l-verżjoni {n}. Mhix il-verżjoni attwali.',
  openCurrent: 'Iftaħ dik attwali',
  archivedBanner:
    'Din il-paġna hija arkivjata. M’għadhiex tintuża fit-tweġibiet; l-istorja tagħha tinżamm.',
  pageViewsLabel: 'Veduti tal-paġna',
  tabRead: 'Aqra',
  tabHistory: 'Storja',
  unknownSection:
    'It-taqsima marbuta mhix parti minn din il-verżjoni. Qed tintwera l-paġna kollha.',
  askAboutPage: 'Staqsi dwar din il-paġna',
  exporting: 'Qed tiġi esportata…',
  exportMarkdown: 'Esporta Markdown',
  loadSuggestionFailed: 'Ma stajniex intellgħu dan is-suġġeriment.',
  evidenceSource: 'Sors',
  evidenceFact: 'Kuntest tal-kumpanija',
  evidenceResult: 'Xogħol issejvjat',
  evidenceUrl: 'Paġna web',
  evidenceDecision: 'Deċiżjoni',
  evidenceReference: 'Referenza',
  evidenceOpenPage: 'Iftaħ il-paġna tal-għarfien',
  evidenceOpenSource: 'Iftaħ is-sors',
  evidenceOpenFact: 'Iftaħ il-kuntest tal-kumpanija',
  evidenceOpenResult: 'Iftaħ ix-xogħol issejvjat',
  evidenceOpenUrl: 'Iftaħ il-paġna web',
  evidenceOpenDecision: 'Iftaħ id-deċiżjoni',
  evidenceOpenReference: 'Iftaħ ir-referenza',
  evidenceDecisionNote: 'Deċiżjoni rreġistrata. M’hemm xejn f’Poneva x’tiftaħ.',
  evidenceFactGone: 'Dan il-kuntest tal-kumpanija m’għadux issejvjat.',
  evidencePageNoRevision: 'Din il-paġna m’għandha l-ebda verżjoni approvata x’tiftaħ.',
  evidencePrivateExcerpt: 'Evidenza privata — ġiet maqsuma biss is-silta ta’ hawn fuq.',
  evidencePrivate: 'Evidenza privata — il-kontenut tagħha ma nqasamx miegħek.',
  evidenceHeading: 'Evidenza',
  evidenceNone: 'Ma ġiet mehmuża l-ebda evidenza. Iżen ir-raġuni ta’ hawn fuq waħedha.',
  changeAdded: 'Miżjud',
  changeRemoved: 'Imneħħi',
  changeChanged: 'Mibdul',
  changeUnchanged: 'Mhux mibdul',
  moreLineCount: 'one:linja oħra|two:linji oħra|few:linji oħra|many:linja oħra|other:linja oħra',
  moreUnchangedLineCount:
    'one:linja oħra mhux mibdula|two:linji oħra mhux mibdula|few:linji oħra mhux mibdula|many:linja oħra mhux mibdula|other:linja oħra mhux mibdula',
  unchangedLineCount:
    'one:linja mhux mibdula|two:linji mhux mibdula|few:linji mhux mibdula|many:linja mhux mibdula|other:linja mhux mibdula',
  skipAdded: '{lines} — murija fil-verżjoni sħiħa',
  skipRemoved: '{lines} imneħħija',
  cutUnchanged: '{lines} mhux murija',
  cutChanged: '{lines} mhux murija, {changes}. Iċċekkjahom fil-verżjoni sħiħa.',
  cutAddedRemoved: '{added} miżjuda u {removed} imneħħija',
  cutAdded: '{added} miżjuda',
  cutRemoved: '{removed} imneħħija',
  lineAddedSr: 'Miżjud:',
  lineRemovedSr: 'Imneħħi:',
  noLinesAdded: 'Taqsima ġdida. It-test tagħha jinsab fil-verżjoni sħiħa hawn taħt.',
  noLinesRemoved: 'Din it-taqsima titneħħa mill-paġna.',
  noLinesChanged: 'Din it-taqsima tinbidel. It-test tagħha jinsab fil-verżjoni sħiħa hawn taħt.',
  diffHeading: 'Bidliet',
  outcomeArchived: 'Arkivjata.',
  outcomeArchivedBody:
    '{title} m’għadhiex tintuża fit-tweġibiet u ħarġet mil-lista tal-paġni. Il-verżjonijiet tagħha, dan is-suġġeriment u d-deċiżjoni jibqgħu fl-istorja tal-paġna.',
  openArchivedPage: 'Iftaħ il-paġna arkivjata',
  outcomeApproved: 'Approvat.',
  outcomeApprovedRevision: 'Il-verżjoni {n} issa hija l-verżjoni approvata ta’ {title}.',
  outcomeApprovedPlain: 'Dan is-suġġeriment ġie approvat.',
  outcomeRestored: 'Il-paġna reġgħet daħlet fil-lista tal-paġni u terġa’ tintuża fit-tweġibiet.',
  outcomeKept:
    'Is-suġġeriment, id-deċiżjoni u kull verżjoni preċedenti jibqgħu fl-istorja tal-paġna.',
  openPage: 'Iftaħ il-paġna',
  outcomeDismissed: 'Imwarrab.',
  outcomeWithdrawn: 'Irtirat.',
  outcomeSuperseded: 'Sostitwit.',
  outcomeSupersededBody:
    'Verżjoni, suġġeriment jew importazzjoni mir-repożitorju aktar ġodda għamlu dan is-suġġeriment skadut. Ma biddel xejn waħdu.',
  outcomeUnchanged: 'Il-paġna tibqa’ kif inhi.',
  approveNewPage: 'Approva l-paġna l-ġdida',
  approveArchive: 'Approva l-arkivjar',
  approveRestoreRevision: 'Irrestawra u approva l-verżjoni {n}',
  approveRevision: 'Approva l-verżjoni {n}',
  approveArchiveNote: 'Jekk tapprova, din il-paġna tiġi arkivjata għal kulħadd ġewwa {company}.',
  approvePublishNote:
    'Jekk tapprova, din il-verżjoni tiġi ppubblikata għal kulħadd ġewwa {company}.',
  approvePublishEvidenceNote:
    'Jekk tapprova, din il-verżjoni u s-siltiet tal-evidenza murija hawn fuq jiġu ppubblikati għal kulħadd ġewwa {company}.',
  archivedTitle: 'Din il-paġna hija arkivjata.',
  alreadyArchivedBody:
    'L-approvazzjoni ma tbiddel xejn, għalhekk dan is-suġġeriment jista’ jitwarrab biss.',
  archivedRestoreBody:
    'L-approvazzjoni terġa’ ġġibha lura: il-paġna terġa’ tidħol fil-lista tal-paġni, fit-tfittxija u fit-tweġibiet b’din il-verżjoni.',
  staleRevisionAction: 'Qabbel mal-aħħar verżjoni',
  staleProposalTitle: 'Dan is-suġġeriment inbidel waqt li kont qed tirrevedih.',
  staleProposalAction: 'Irrevedi l-aħħar verżjoni',
  staleArchivedTitle:
    'Din il-paġna ġiet arkivjata waqt li kont qed tirrevediha. L-approvazzjoni ta’ dan is-suġġeriment terġa’ ġġibha lura.',
  staleArchivedAction: 'Erġa’ rrevedi',
  suggestionMissingTitle: 'Dan is-suġġeriment mhux disponibbli.',
  suggestionMissingBody:
    'Forsi ġie rtirat, jew huwa ta’ xi ħadd ieħor u ma ntbagħatx għar-reviżjoni tal-kumpanija.',
  decideUnconfirmed:
    'Ma stajniex nikkonfermaw id-deċiżjoni tiegħek. L-istatus muri huwa l-aħħar wieħed minn Poneva; iċċekkjah qabel ma terġa’ tipprova.',
  decideFailed: 'Ma stajniex nissejvjaw id-deċiżjoni tiegħek.',
  discussPrompt: 'Għinni ntejjeb l-aġġornament issuġġerit tal-għarfien għal “{title}” ({link}).',
  conflictBody:
    'Dan is-suġġeriment inkiteb fuq il-verżjoni {base}; il-verżjoni attwali hija {current}. Jekk jiġi approvat jikteb fuq dik il-bidla, għalhekk ma jistax jiġi approvat kif inhu.',
  conflictBodyPlain:
    'Dan is-suġġeriment inkiteb fuq verżjoni preċedenti, għalhekk ma jistax jiġi approvat kif inhu.',
  openLatest: 'Iftaħ l-aħħar verżjoni',
  reworkInChat: 'Erġa’ aħdem fuqu fiċ-chat',
  factReason: 'Raġuni',
  factNoReason: 'Ma ngħatat l-ebda raġuni.',
  factAudience: 'Udjenza',
  factRevision: 'Verżjoni',
  revisionNew: 'Paġna ġdida, verżjoni 1',
  revisionArchiveAfter: 'Arkivja wara l-verżjoni {n}',
  revisionWrittenAgainst: 'Miktub fuq il-verżjoni {base}; il-verżjoni attwali hija {current}',
  revisionCurrentToProposed: 'Verżjoni attwali {base} → verżjoni proposta {next}',
  revisionProposed: 'Verżjoni proposta {next}',
  proposedPage: 'Paġna proposta',
  archivingHeading: 'X’jagħmel l-arkivjar',
  archivingBody:
    'Il-paġna ma tibqax tintuża fit-tweġibiet u toħroġ mil-lista tal-paġni. Il-verżjonijiet tagħha u din id-deċiżjoni jinżammu.',
  noComparison: 'Tqabbil tat-taqsimiet mhux disponibbli għal dan is-suġġeriment.',
  showComplete: 'Uri l-verżjoni sħiħa',
  approving: 'Qed jiġi approvat…',
  dismissing: 'Qed jitwarrab…',
  dismiss: 'Warrab',
  withdrawing: 'Qed jiġi rtirat…',
  withdraw: 'Irtira',
  editInChat: 'Editja fiċ-chat',
  waitingForPublisher: 'Qed jistenna li pubblikatur tal-kumpanija jirrevedih.',
  snapshotTooLarge: 'Dan is-snapshot huwa akbar minn 8 MB. Oħolqu b’inqas dokumenti.',
  snapshotNotSnapshot:
    'Dan il-fajl mhuwiex snapshot tal-għarfien. Agħżel il-fajl JSON li kiteb l-iskript tas-snapshot.',
  snapshotEmpty: 'Dan is-snapshot ma fih l-ebda dokument.',
  readDocumentFailed: 'Ma stajniex naqraw dan id-dokument. Erġa’ pprova.',
  readingDocument: 'Qed jinqara d-dokument…',
  hideText: 'Aħbi t-test',
  readText: 'Aqra t-test',
  textOf: 'Test ta’ {title}',
  gitSnapshot: 'Snapshot Git {commit}',
  repositorySnapshot: 'Snapshot tar-repożitorju',
  importNewHeading: '{pages} · approvati meta tapplika',
  importNewNote:
    'Kull waħda tiġi ppubblikata bħala paġna approvata għal kulħadd ġewwa {company}, mingħajr reviżjoni oħra. Aqra kull waħda qabel ma tapplika.',
  importChangedHeading: '{pages} · mibgħuta għar-reviżjoni',
  importChangedNote:
    'Kull waħda ssir aġġornament issuġġerit. Il-paġna tagħha tinbidel biss meta pubblikatur japprovah f’Għar-reviżjoni, li juri x’inbidel.',
  unchangedDocumentCount:
    'one:dokument mhux mibdul|two:dokumenti mhux mibdula|few:dokumenti mhux mibdula|many:dokument mhux mibdul|other:dokument mhux mibdul',
  unchangedNote: 'Dawn diġà jaqblu mal-paġni approvati tagħhom. Xejn ma jinkiteb għalihom.',
  stagedHeading: 'Ippreparati iżda mhux applikati',
  excludedSummary: '{documents} barra minn dan is-snapshot',
  countsLine: '{newPages} · {changedPages} għar-reviżjoni · {unchanged} mhux mibdula',
  importAlreadyDiscarded: 'Din l-importazzjoni diġà ġiet skartata.',
  confirmLabel: 'Ikkonferma l-importazzjoni',
  unchangedKeepCount:
    'one:dokument mhux mibdul iżomm il-paġna tiegħu|two:dokumenti mhux mibdula jżommu l-paġni tagħhom|few:dokumenti mhux mibdula jżommu l-paġni tagħhom|many:dokument mhux mibdul iżommu l-paġni tagħhom|other:dokument mhux mibdul iżommu l-paġni tagħhom',
  confirmBody:
    'Tapplika din l-importazzjoni għal kulħadd ġewwa {company}? {newPages} jiġu approvati bħala verżjoni 1, {changedPages} jistennew ir-reviżjoni, u {unchanged}. Is-suġġerimenti ta’ importazzjonijiet preċedenti għal dawn il-paġni jiġu rtirati.',
  applying: 'Qed tiġi applikata…',
  applyImport: 'Applika l-importazzjoni',
  chooseAnother: 'Agħżel fajl ieħor',
  allCurrent: 'Kollox f’dan is-snapshot diġà huwa aġġornat.',
  importApplied: 'L-importazzjoni ġiet applikata.',
  appliedSummary: '{pages} maħluqa · {changes} jistennew ir-reviżjoni · {unchanged} mhux mibdula.',
  appliedIndexing:
    'Il-paġni l-ġodda jkunu jistgħu jinstabu fiċ-chat ladarba jintemm l-indiċjar. Il-progress jidher fil-preparazzjoni tas-sorsi.',
  openPages: 'Iftaħ Paġni',
  reviewChanges: 'Irrevedi {changes}',
  checkIndexing: 'Iċċekkja l-progress tal-indiċjar',
  sendSnapshotFailed: 'Ma stajniex nibagħtu dan is-snapshot. Erġa’ pprova.',
  openStagedFailed: 'Ma stajniex niftħu din l-importazzjoni ppreparata.',
  applyUnconfirmed:
    'Ma stajniex nikkonfermaw jekk l-importazzjoni ġietx applikata. Iċċekkja Paġni qabel ma terġa’ tipprova.',
  applyFailed: 'Ma stajniex napplikaw din l-importazzjoni.',
  importHeading: 'Importa paġni mir-repożitorju',
  backToPages: 'Lura għall-paġni',
  importLead:
    'Oħloq snapshot b’{command}, imbagħad agħżel il-fajl. Tara kull dokument u x’jibdel qabel ma jiġi ssejvjat xejn.',
  snapshotFileLabel: 'Fajl tas-snapshot tal-għarfien',
  readingSnapshot: 'Qed jinqara s-snapshot…',
  openingStaged: 'Qed tinfetaħ l-importazzjoni ppreparata…',
  chooseSnapshot: 'Agħżel fajl tas-snapshot',
  factOrigin: 'Oriġini',
  factContents: 'Kontenut',
  importOnlyListed: 'Jiġu importati biss id-dokumenti elenkati hawn.',
  importRepositoryAuthoritative:
    'Ir-repożitorju jibqa’ awtorevoli; id-dokumenti mibdula jsiru suġġerimenti għar-reviżjoni.',
  overviewReviewChanges: 'Irrevedi l-bidliet',
  overviewConnectAgents: 'Ikkonnettja aġenti esterni',
  overviewEyebrow: 'Fehim komuni',
  overviewTitle: '{company}, fil-kuntest.',
  overviewLeadFallback:
    'L-għarfien tal-kumpanija tiegħek jibda bil-kuntest li taqsam. Ibnu fehim tan-negozju tiegħek, flimkien.',
  overviewBody:
    'Il-kuntest tal-kumpanija u l-materjal tas-sorsi jagħtu lil Poneva punt tat-tluq — mhux kull ma hemm x’tkun taf dwar {company}. Kompli ibni dan il-fehim hekk kif in-negozju tiegħek jevolvi.',
  overviewAskPrompt: 'X’taf dwar il-kumpanija tagħna, u x’ikun utli li nżidu?',
  overviewAsk: 'Staqsi dwar {company}',
  overviewAddSources: 'Żid sorsi',
  contextEyebrow: 'X’jagħti kuntest lit-tweġibiet',
  contextTitle: 'In-negozju wara l-mistoqsija.',
  contextBody:
    'Is-sorsi tas-siti web jispjegaw in-negozju pubbliku. In-noti tal-kumpanija jżidu t-terminoloġija, il-prijoritajiet u l-mod kif taħdmu.',
  contextPrompt:
    'Għinni ninċara l-prijoritajiet tal-kumpanija u l-preferenzi tax-xogħol li għandna niftakru.',
  contextAction: 'Ibni l-fehim tagħna',
  learnEyebrow: 'Spazju biex nitgħallmu',
  learnTitle: 'Ibda b’dak li jgħodd l-iktar issa.',
  learnBody:
    'Daħħal materjal tas-sorsi jew iċċara kif taħdem il-kumpanija tiegħek. Poneva jista’ jissuġġerixxi bidliet dejjiema biex tirrevedihom.',
  learnPrompt:
    'Abbażi tal-għarfien eżistenti tal-kumpanija tagħna, liema informazzjoni importanti hija nieqsa għax-xogħol li rridu nagħmlu?',
  learnAction: 'Iddiskuti x’ikun utli',
  canvasEmptyTitle: 'Ftit kuntest imur ’il bogħod.',
  canvasEmptyBody:
    'Il-profil tal-kumpanija tiegħek huwa l-punt tat-tluq. Żid materjal tas-sorsi u noti riveduti biex tgħin lil Poneva jifhem ix-xogħol tiegħek.',
  pageEyebrow: 'Spazju tax-xogħol ta’ {company}',
  pageTitle: 'Għarfien tal-kumpanija',
  pageDescription: 'Is-sorsi u l-fehim wara x-xogħol ta’ Poneva.',
  tabOverview: 'Ħarsa ġenerali',
  tabPages: 'Paġni',
  tabSources: 'Sorsi',
  tabReview: 'Għar-reviżjoni',
  proposalApproved: 'Kuntest tal-kumpanija approvat',
  proposalDismissed: 'Suġġeriment imwarrab',
  proposalRemoval: 'Tneħħija proposta',
  proposalCorrection: 'Korrezzjoni proposta',
  proposalContext: 'Kuntest tal-kumpanija propost',
  proposalCurrent: 'Fehim attwali',
  proposalFactGone:
    'Il-fatt issejvjat m’għadux disponibbli. Aġġorna l-għarfien tal-kumpanija qabel tirrevedi din it-tneħħija.',
  proposalReviewFallback: 'Irrevedi l-kuntest tal-kumpanija propost.',
  proposalNotSaved: 'Għadu ma ġiex issejvjat. Is-sorsi oriġinali jibqgħu kif inhuma.',
  proposalWaiting:
    'Qed jistenna r-reviżjoni · pubblikatur tal-kumpanija jiddeċiedi fl-Inbox tiegħu',
  proposalSaving: 'Qed jiġi ssejvjat…',
  proposalApproveRemoval: 'Approva t-tneħħija',
  proposalApproveClarification: 'Approva l-kjarifika',
  factLabel: 'Fatt tal-kumpanija',
  factEyebrow: 'Fatt · Kulħadd ġewwa {company}',
  factSuggestCorrection: 'Issuġġerixxi korrezzjoni',
  factAskPrompt: 'Għinni nifhem jew niċċara dan il-kuntest tal-kumpanija ssejvjat: “{content}”',
  factAsk: 'Staqsi dwaru',
  companyContextHeading: 'Kuntest tal-kumpanija',
  companyContextPrompt:
    'Nixtieq niċċara l-għarfien tal-kumpanija tagħna. Għinni nirrevedi dak li nafu u nipproponi aġġornament.',
  companyContextEmpty:
    'Għad m’hemm l-ebda nota approvata. Ibda konversazzjoni dwar il-kumpanija tiegħek, jew żid materjal tas-sorsi hawn taħt.',
  refineInChat: 'Irfina fiċ-chat',
  reviewPanelLabel: 'Bidliet fl-għarfien għar-reviżjoni',
  suggestedUpdatesHeading: 'Aġġornamenti ssuġġeriti',
  suggestedUpdatesIntro:
    'Suġġerimenti mill-konversazzjonijiet tiegħek. Inti tiddeċiedi x’isir parti mill-għarfien dejjiemi tal-kumpanija tiegħek.',
  reviewEmptyTitle: 'M’hemm xejn jistenna r-reviżjoni tiegħek.',
  reviewEmptyBody:
    'Meta Poneva jissuġġerixxi bidla fl-għarfien tal-kumpanija tiegħek, issibha hawn. Il-bidliet dejjiema dejjem jeħtieġu l-approvazzjoni tiegħek.',
  reviewEmptyPrompt:
    'Għinni nirrevedi l-għarfien tal-kumpanija tagħna u ssuġġerixxi x’ikun utli li niċċaraw wara.',
  inclusionPendingApproval: 'Il-bidla fl-inklużjoni fl-għarfien intbagħtet għall-approvazzjoni.',
  sourcesFileIncluded:
    'Il-fajl ġie inkluż fit-tfittxija tal-għarfien għall-udjenza attwali tiegħu.',
  sourcesAddFailed: 'Dan is-sors ma setax jiżdied.',
  sourcesHeading: 'Il-materjal wara t-tweġibiet.',
  sourcesIntro:
    'Poneva jfittex fil-materjal kollu tas-sorsi, mhux biss fil-ħarsa ġenerali. Żomm l-oriġinali, ara x’inhu lest, u agħżel x’jinforma t-tweġibiet tiegħek.',
  addSourceHeading: 'Żid materjal mill-kumpanija tiegħek',
  addSourceIntro:
    'Is-sorsi mtella’ jibqgħu privati fil-Librerija tiegħek u jinfurmaw biss it-tweġibiet tiegħek. Agħżel Aqsam meta trid tagħmilhom disponibbli għall-kollegi.',
  uploadSource: 'Tella’ sors',
  addSourcePrompt:
    'Għinni nżid stqarrija tal-kumpanija bħala sors intern kondiviż. Staqsini x’nixtieq nirreġistra; tivvinta l-ebda kontenut. Il-bidliet dejjiema fil-fehim tal-kumpanija xorta jeħtieġu l-approvazzjoni tiegħi.',
  addThroughChat: 'Żid permezz taċ-chat',
  addingSource: 'Qed jiżdied…',
  addToKnowledge: 'Żid mal-għarfien',
  uploadFormats: 'TXT, Markdown, CSV u JSON · Sa 5 MB għal kull fajl',
  sourceExcluded: 'Eskluż mit-tweġibiet',
  sourcePreparationFailed: 'It-tħejjija falliet',
  sourcePreparing: 'Qed jitħejja għat-tfittxija',
  sourceWaiting: 'Qed jistenna li jitħejja',
  sourceReadinessUnknown: 'L-istat tat-tħejjija mhux disponibbli',
  sourceRetryQueued: 'It-tħejjija ddaħħlet fil-kju. L-istat jiġi aġġornat meta tintemm.',
  sourceIncludedNotice: 'Is-sors ġie inkluż. Poneva se jħejjih għat-tfittxija.',
  sourceExcludedNotice: 'Eskluż mit-tweġibiet. Is-sors oriġinali jinżamm.',
  sourceUpdateFailed: 'Dan is-sors ma setax jiġi aġġornat.',
  sourceOriginalMaterial: 'Materjal oriġinali tas-sors',
  sourceDiscuss: 'Iddiskuti fiċ-chat',
  sourceDiscussPrompt: 'Għinni nifhem jew niċċara “{title}”.',
  sourceExclude: 'Eskludi mit-tweġibiet',
  sourceInclude: 'Inkludi fit-tweġibiet',
  sourcesLoadFailed: 'Ma stajniex intellgħu s-sorsi tiegħek.',
  sourceLibraryLabel: 'Librerija tas-sorsi tal-kumpanija',
  sourceListCaption: 'Sorsi oriġinali · inklużi u esklużi',
  sourceSearchLabel: 'Fittex fis-sorsi tal-kumpanija',
  sourceSearchPlaceholder: 'Fittex fis-sorsi tiegħek…',
  sourcesFinding: 'Qed infittxu s-sorsi tiegħek…',
  sourcePagesLabel: 'Paġnazzjoni tas-sorsi',
  sourceRange: '{from}–{to} minn {count}',
  sourceCount: 'one:sors|two:sorsi|few:sorsi|many:sors|other:sors',
  sourcePrevious: 'Preċedenti',
  sourceNext: 'Li jmiss',
  sourceNoMatchTitle: 'L-ebda sors ma jaqbel.',
  sourceNoMatchBody: 'Ipprova frażi jew isem ta’ sors differenti.',
  sourceEmptyTitle: 'Agħti lill-mistoqsijiet tiegħek punt tat-tluq aktar sod.',
  sourceEmptyBody:
    'Żid dokumenti tal-kumpanija, data tal-prodotti jew noti tax-xogħol. Poneva jista’ juża l-materjal kollu tas-sorsi fil-konversazzjonijiet u fl-Skills.',
  indexCheckFailed: 'Ma stajniex niċċekkjaw it-tħejjija tas-sorsi.',
  indexRetryQueued:
    'L-entrati tal-għarfien li fallew iddaħħlu fil-kju għat-tħejjija. Il-materjal tas-sorsi tiegħek ma nbidilx.',
  indexQueueFailed: 'Ma stajniex indaħħlu t-tħejjija fil-kju. Erġa’ pprova.',
  indexPreparing: 'Qed jitħejja għarfien ġdid għall-konversazzjonijiet tiegħek…',
  indexAttention: 'Xi għarfien jeħtieġ attenzjoni.',
  queuing: 'Qed jiddaħħal fil-kju…',
  retryPreparation: 'Erġa’ pprova t-tħejjija',
  sourceKindStatement: 'Stqarrija tal-kumpanija',
  sourceKindWebsite: 'Sit web',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:tweġiba|two:tweġibiet|few:tweġibiet|many:tweġiba|other:tweġiba',
  factUsedThisWeek: 'Użat din il-ġimgħa: {answers}',
  factLastUsed: 'l-aħħar użu: {when}',
  factToday: 'illum',
  factYesterday: 'ilbieraħ',
  factImpact: 'Din il-bidla taffettwa fatt użat din il-ġimgħa ({answers}).',
  factCorrectionAbout: 'Dwar dan il-fatt tal-kumpanija: “{content}” ({link})',
  factCorrectionOutdated: 'Dan m’għadux aġġornat:',
  sourceCanvasRecorded: 'Materjal tas-sorsi rreġistrat',
  sourceCanvasNotIncluded:
    'Mhuwiex inkluż fl-għarfien tal-kumpanija. L-oriġinal jinżamm għar-referenza u xorta jista’ jintuża f’konverżazzjoni speċifika.',
  sourceCanvasOpenOriginal: 'Iftaħ is-sors oriġinali',
  sourceCanvasUnavailable: 'Il-kontenut tas-sors mhuwiex disponibbli.',
  sourceCanvasDiscussPrompt: 'Għinni nifhem jew niċċara “{title}”.',
  sourceCanvasDiscuss: 'Iddiskuti dan is-sors',
  sourceCanvasCorrectionNote:
    'Korrezzjoni ssir kuntest tal-kumpanija propost. Is-sors irreġistrat jibqa’ l-istess.',
  contextCanvasEyebrow: 'Kuntest tal-kumpanija disponibbli',
  contextCanvasTitle: 'L-għarfien wara din il-konverżazzjoni.',
  contextCanvasBody:
    'Fehim approvat u l-materjal tas-sorsi li żiedet il-kumpanija tiegħek. Disponibbli fiċ-chat u f’Skills.',
  contextCanvasOpen: 'Iftaħ Għarfien',
};

export default mt;
